module.exports = __webpack_public_path__ + "img/Monte_Kope_110.de17e6be.jpg";